module.exports = "/images/pat.png?11645621381dcf59ada47949435f0ce7";